import { combineReducers } from 'redux';
import userReducer from './user/userReducer';
import providersReducer from './providers/providersReducer';
import locationsReducer from './locations/locationsReducer';
import searchReducer from './search/searchReducer';

export default combineReducers({
  user: userReducer,
  providers: providersReducer,
  locations: locationsReducer,
  search: searchReducer,
});



// WEBPACK FOOTER //
// ./src/store/modules/db/dbReducer.js